import { render, staticRenderFns } from "./VisitFieldEmail.vue?vue&type=template&id=f0890ee8&"
import script from "./VisitFieldEmail.vue?vue&type=script&lang=js&"
export * from "./VisitFieldEmail.vue?vue&type=script&lang=js&"
import style0 from "./VisitFieldEmail.vue?vue&type=style&index=0&id=f0890ee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports